import {
  ButtonContainerAuth,
  ButtonsContainer,
  ButtonSignIn,
  ButtonSignUp,
  HeaderContainer,
} from "./Header.styled";
import { useState } from "react";
import { NavLink } from "react-router";
import { LogoApp } from "../../../LogoApp/LogoApp";
import { ModelWindow } from "../../../ModelWindow/ModelWindow";
import { SignUpModel } from "./SignUpModel/SignUpModel";
import { SignInModel } from "./SignInModel/SignInModel";
import { useLanguageContext } from "../../../Languages/Langs/LanguageContext";
import { ForgotPasswordModel } from "./ForgotPasswordModel/ForgotPasswordModel";

export const PublicHeader = () => {
  const { t } = useLanguageContext();
  const [showSignUp, setShowSignUp] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);

  const [showSignIn, setShowSignIn] = useState(false);
  const [isSignInOpen, setIsSignInOpen] = useState(false);

  const openSignUp = () => {
    setShowSignUp(true);
    setTimeout(() => setIsSignUpOpen(true), 0);
  };

  const closeSignUp = () => {
    setIsSignUpOpen(false);
    setTimeout(() => setShowSignUp(false), 250);
  };

  const openSignIn = () => {
    setShowSignIn(true);
    setTimeout(() => setIsSignInOpen(true), 0);
  };

  const closeSignIn = () => {
    setIsSignInOpen(false);
    setTimeout(() => setShowSignIn(false), 250);
  };

  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  const openForgotPassword = () => {
    setShowForgotPassword(true);
    setTimeout(() => setIsForgotPasswordOpen(true), 0);
  };

  const closeForgotPassword = () => {
    setIsForgotPasswordOpen(false);
    setTimeout(() => setShowForgotPassword(false), 250);
  };

  return (
    <>
      <header>
        <HeaderContainer>
          <NavLink to="/">
            <LogoApp />
          </NavLink>

          <ButtonContainerAuth>
            <ButtonsContainer>
              <ButtonSignUp type="button" onClick={openSignUp}>
                {t("publicTranslate.buttonSignUpModel")}
              </ButtonSignUp>
            </ButtonsContainer>
            <ButtonsContainer>
              <ButtonSignIn type="button" onClick={openSignIn}>
                {t("publicTranslate.buttonSignInModel")}
              </ButtonSignIn>
            </ButtonsContainer>
          </ButtonContainerAuth>
        </HeaderContainer>

        {showSignUp && (
          <ModelWindow onClose={closeSignUp} isOpen={isSignUpOpen}>
            <SignUpModel onClose={closeSignUp} />
          </ModelWindow>
        )}

        {showSignIn && (
          <ModelWindow onClose={closeSignIn} isOpen={isSignInOpen}>
            <SignInModel
              onClose={closeSignIn}
              onForgotPassword={() => {
                closeSignIn(); // закриваємо SignIn
                openForgotPassword(); // відкриваємо ForgotPassword
              }}
            />
          </ModelWindow>
        )}
        {showForgotPassword && (
          <ModelWindow
            onClose={closeForgotPassword}
            isOpen={isForgotPasswordOpen}
          >
            <ForgotPasswordModel onClose={closeForgotPassword} />
          </ModelWindow>
        )}
      </header>
    </>
  );
};
